import {getElementByTagName} from '../utils';

const createCopyright = (hash) => {
    const footer = getElementByTagName('footer');

    for (let item of Array.from(footer.childNodes)) {
        if (item.classList.contains('copyright')) {
            return;
        }
    }

    const p = document.createElement('p');
    p.classList.add('copyright');
    p.innerText = generateCopyrightText();

    footer.append(p);
};

const generateCopyrightText = () => `smff © ${(new Date()).getFullYear()} this.`;


export default createCopyright;
